import { LivEnvironment } from './environment.interface';

export const environment: LivEnvironment = {
  production: true,
  appVersion: 'v726',
  USERDATA_KEY: 'authf649fc9a5f55',
  isMockEnabled: true,
  apiUrl: 'https://api-prod.vescent.co/api',   // TO BE CHANGED
  twilioUrl: 'https://twilio-serverless-5003-dev.twil.io',
  baseUrl: 'https://api-prod.vescent.co/', // TO BE CHANGED
  // apiUrl: 'mysite.com/api'
  gtmId: 'GTM-NB7Q29VQ',
  sharpenApi: 'https://shrpn.me/api',
  sharpenApiKey: '0K3XONyy.5S1AVYyXMz4XpBIld2jZDYUtX48RIsBZ',
  sharpenAnalytics: 'https://analytics.shrpn.me/matomo.php',
  sharpenAnalyticsType: '1',
  landbotId: 'H-2876879-R88NON3I9SRSTHFW',
};
